import { colors } from "@/theme";
import { SxProps, Theme } from "@mui/material";

const pageSize = 20;

const initialPaginationModel = {
  page: 0,
  pageSize: pageSize,
};

const firstPage = initialPaginationModel.page + 1;


const DataGridDefaultStyle:SxProps<Theme> = {
  border: 'none',
  background: 'transparent',
  fontFamily: 'PF DIN Text Pro',
  '.MuiDataGrid-columnHeaders': {
    // background: '#fafbfc',
    fontWeight: 700,
    fontSize: '15px',
    textTransform: 'uppercase',
    borderTop: `1px solid ${colors.neutralGrey800}`,
    color: '#1a202c',
    letterSpacing: '0.5px',
    minHeight: '56px',
    maxHeight: '56px',
  },
  '.MuiDataGrid-cell': {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    color: '#2d3748',
    padding: '16px 8px',
    // borderBottom: `1px solid ${colors.neutralGrey800}`,
  },
  '.MuiDataGrid-row': {
    minHeight: '56px',
    maxHeight: 'auto',
    background: '#fff',
    transition: 'background 0.2s',
    borderBottom: `1px solid ${colors.neutralGrey800}`
  },
  '.MuiDataGrid-row.Mui-selected, .MuiDataGrid-row[data-rowindex][aria-selected="true"]': {
    background: '#e6f0fa !important',
  },
  '.MuiDataGrid-row--editing': {
    background: '#e6f0fa',
  },
  '.MuiDataGrid-cell--editing': {
    background: '#e6f0fa',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
  },
  '.MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '.MuiDataGrid-footerContainer': {
    // borderTop: '1px solid #e5e7eb',
    background: '#fafbfc',
  },
  '.MuiDataGrid-actionsCell': {
    display: 'flex',
    gap: '8px',
  },
  '.MuiButtonBase-root': {
    borderRadius: '8px',
    minWidth: '36px',
    minHeight: '36px',
    fontWeight: 500,
    fontSize: '15px',
    boxShadow: 'none',
    textTransform: 'none',
  },
  '.MuiSvgIcon-root': {
    fontSize: '20px',
  },
  '.MuiDataGrid-iconButtonContainer': {
    justifyContent: 'flex-end',
  },
  '.MuiDataGrid-row .MuiDataGrid-cell:last-of-type': {
    paddingRight: '24px',
  },
  '.MuiDataGrid-row .MuiDataGrid-cell:first-of-type': {
    paddingLeft: '24px',
  },
}

export {
  pageSize,
  initialPaginationModel,
  firstPage,
  DataGridDefaultStyle
};
